import React from 'react';

import Select from '../../../../components/Select';
import useStyles from './styles';

const DropDownAnswer = ({ editableAnswer, setEditableAnswer, options }) => {
  const classes = useStyles();

  const handleOnChange = (e) => {
    setEditableAnswer(e.target.value);
  };

  return (
    <div className={classes.content}>
      <Select
        name="selected"
        items={options}
        value={editableAnswer || ''}
        onChange={(e) => handleOnChange(e)}
        fullWidth
      />
    </div>
  );
};

export default DropDownAnswer;
